function elementReady(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
      let observer;
      let timer;
      let el = document.querySelector(selector);
  
      if (el) {
        resolve(el);
        return;
      }
  
      observer = new MutationObserver((mutationRecords, observer) => {
        Array.from(document.querySelectorAll(selector)).forEach((element) => {
          resolve(element);
          observer.disconnect();
          clearTimeout(timer);
        });
      });
  
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
  
      if (timeout) {
        timer = setTimeout(() => {
          observer.disconnect();
          reject(`Timed out observing mutation for: ${selector}`);
        }, timeout);
      }
    });
  }
  
window.elementReady = elementReady; 

function asyncTimeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

window.asyncTimeout = asyncTimeout;

window.isElementInViewport = function(el) {
  const rect = el.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};